import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { Router } from '@angular/router';
import { TeamService } from '../../Services/team.service';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { GSL } from '../../Models/Team';
import { VERBIAGE } from 'src/app/config';

@Component({
    selector: 'team-member-add',
    templateUrl: './team-member-add.component.html',
    styleUrls: ['./team-member-add.component.scss']
})

export class TeamMemberAddComponent implements OnInit, OnDestroy {

    gsl: GSL[]; profilePic = null; imageSrc = '/assets/images/user_icon.png';

    // Set input masks for form controls
    inputMask = { phone: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] };

    constructor(
        private _shared: SharedService, private _router: Router, private _team: TeamService,
        private _notify: NotificationService
    ) {
        // Show loader
        this._shared.loadingState = true;
        // Setting up page title
        this._shared.pageTitle = 'Add Member';
        // Set up page controls
        const _this = this;
        this._shared.pageControls = [
            { type: '-icon-', title: 'Previous page', icon: 'arrow_back', action() {
                _this._router.navigate(['/dashboard/teammembers']);
            }}
        ];
    }

    ngOnInit() {
        this._team.getGSL().subscribe(res => {
            this.gsl = <GSL[]>res['result'];
            
            if (this.gsl.length === 0) {

                const _this = this;
                this._notify.openDialog({
                    title: VERBIAGE.GSL_NOT_PRESENT_TITLE, body: VERBIAGE.GSL_NOT_PRESENT_BODY,
                    handlers: [
                        { type: '-raised-', text: 'Manage GSL', action() {
                            _this._router.navigate(['/dashboard/team/gsl']);
                        }}
                    ]
                })

            }
            
            // Hide loader
            this._shared.loadingState = false;
        });
    }

    addTeamMember(form) {
        if (!form.valid) { return; }
        // Add new Member in database
        this._team.addTeamMember(form.value).subscribe(res => {
            if (res['status'] === 'OK') {
                // Check if picture is present
                if (!this.profilePic) {
                    this._notify.toastMessage({ color:'accent', message: form.value.fullName + VERBIAGE.ADD_NEW_MEMBER_SUCCESS, duration: 3000 });        
                    this._router.navigate(['/dashboard/teammembers']);
                } else {
                    // On successfull update
                    let picture: FormData = new FormData();
                    picture.append('picture', this.profilePic, this.profilePic.name);
                    this._team.updateTeamMemberProfilePic(res['result'], picture).subscribe(result => {
                        if (result['status'] === 'OK') {
                            this._notify.toastMessage({ color: 'accent', message: form.value.fullName + VERBIAGE.ADD_NEW_MEMBER_SUCCESS, duration: 3000 });
                            this._router.navigate(['/dashboard/teammembers']);
                        }
                    });
                }
            }
        }, (err) => {
            // Notify user on error.
            this._notify.openDialog({
                color: 'warn', title: VERBIAGE.ADD_NEW_MEMBER_FAIL_TITLE, body: VERBIAGE.ADD_NEW_MEMBER_FAIL + err.status
            });
        });
    }

    setProfilePic(e) {
        if (e.target.files && e.target.files.length) {
            var reader = new FileReader();
            reader.onload = function (el) {
                this.imageSrc = el.target.result;
            }.bind(this);

            reader.readAsDataURL(e.target.files[0]);

            this.profilePic = e.target.files[0];
        }
    }
    
    ngOnDestroy() {
        // Remove page controls
        this._shared.pageControls = null;
    }
}